<template>
  <div class="container">
    <div class="company inner">
      <div class="posite">
        <ul class="posite-menu"></ul>
         <div class="posite-map posite-map1">
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
           <router-link to="/jzabout">关于我们</router-link>
          <b>></b>
          <span>{{activeName}}</span>
        </div>
      </div>
      <CompanyItem @change="changeName($event)" :compatyData='compatyData'></CompanyItem>
    </div>
  </div>
</template>

<script>
import CompanyItem from '@/components/common/CompanyItem.vue'
export default {
  data () {
    return {
      compatyData: [],
      activeName: ''
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/fdata/page_show?catid=89')
      const { data: res1 } = await this.$http.get('/fdata/page_show?catid=90')
      const { data: res2 } = await this.$http.get('/fdata/page_show?catid=91')
      if (res.code === 1) {
        this.compatyData.push(res.data)
        this.compatyData.push(res1.data)
        this.compatyData.push(res2.data)
        this.activeName = this.compatyData[this.$route.query.layIndex].name
      }
    },
    changeName (value) {
      this.activeName = value
    }
  },
  mounted () {
    this.getData()
  },
  components: {
    CompanyItem
  },
  watch: {
    $route (to, from) {
      this.activeName = this.compatyData[this.$route.query.layIndex].name
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
@import url("@/assets/css/common/index.less");
</style>
